import { FC } from "react"
import { PageTemplate } from "../components/pageTemplate/PageTemplate"

const Notfound: FC = () => {
  return (
    <PageTemplate
      pageTitle="404 Page Not Found"
      pageContentClassName="info-page-container gradient-bg"
    >
      <article className="not-found-page d-flex flex-column align-items-center">
        <header>404</header>
        <p>Whoops! This page is not available...</p>
      </article>
    </PageTemplate>
  )
}

export default Notfound
